@if (!isFinished()) {
  <div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
      <a (click)="back()">
        <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
      </a>
      <div class="p-2 flex-grow-1 pl-2">
        <h1 class="text-dark text-center">Detalle del turno</h1>
      </div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2 mt-0">
      <div class="row row-cols-12 mt-0">
        <div class="col-8">
          <div class="text-p p-3 pb-0 nameUser">
            #{{ ordenPrestador?.id }}
          </div>
          <div class="text-p p-3 pt-0 pb-3 dateUser fw-bold">
            <span style="color:#205EA5">{{ nombreCliente }}</span>
          </div>
        </div>
        <div class="col-4 col-profile">
          <a [routerLink]="[url_perfil_cliente]">
            <img
              class="text-end rounded-circle business-profile"
              [src]="preview_img_avatar == '' ? './assets/img/user-init.png' : preview_img_avatar"
            />
          </a>
        </div>
      </div>

      <hr class="divisor mt-3 mb-1" />

      <div class="text-p p-3 pt-3 pb-0 locationUser">
        <div class="row form-switch ps-0 mb-3">
          <div class="col-5 col-lg-8 title-product text-dark">
            <b>Especialidad:</b>
          </div>
          <div class="col-7 col-lg-2 col-4 col-lg-4 text-end" style="font-size:0.9em">
            {{ nombreEspecialidad }}
          </div>
        </div>

        <div class="row form-switch ps-0 mb-3">
          <div class="col-5 col-lg-8 title-product text-dark">
            <b>Prestación:</b>
          </div>
          <div class="col-7 col-lg-2 col-4 col-lg-4 text-end" style="font-size:0.9em">
            {{ nombrePrestacion }}
          </div>
        </div>

        <div class="row form-switch ps-0 mb-3">
          <div class="col-3 col-lg-8 title-product text-dark">
            <b>Fechas deseadas:</b>
          </div>
          <div class="col-9 col-lg-2 col-4 col-lg-4 text-end" style="font-size:0.9em">
            {{ ordenPrestador?.d_fecha_uno | date: 'dd/MM/yyyy' }}
            @if (ordenPrestador?.d_fecha_dos) {
              <span>, {{ ordenPrestador?.d_fecha_dos | date: 'dd/MM/yyyy' }}</span>
            }
            @if (ordenPrestador?.d_fecha_tres) {
              <span>, {{ ordenPrestador?.d_fecha_tres | date: 'dd/MM/yyyy' }}</span>
            }
          </div>
        </div>

        <div class="row form-switch ps-0 mb-3">
          <div class="col-3 col-lg-8 title-product text-dark">
            <b>Horario:</b>
          </div>
          <div class="col-9 col-lg-2 col-4 col-lg-4 text-end" style="font-size:0.9em">
            @if (ordenPrestador?.b_manana) { <span>Mañana</span> }
            @if ((ordenPrestador?.b_manana && ordenPrestador?.b_tarde) || (ordenPrestador?.b_manana && ordenPrestador?.b_noche)) { <span> | </span> }
            @if (ordenPrestador?.b_tarde) { <span>Tarde</span> }
            @if (ordenPrestador?.b_tarde && ordenPrestador?.b_noche) { <span> | </span> }
            @if (ordenPrestador?.b_noche) { <span>Noche</span> }
          </div>
        </div>

        <div class="row form-switch ps-0 mb-4">
          <div class="col-3 col-lg-8 title-product text-dark">
            <b>Zona:</b>
          </div>
          <div class="col-9 col-lg-2 col-4 col-lg-4 text-end" style="font-size:0.9em">
            {{ ordenPrestador?.x_zona }}
          </div>
        </div>

        @if (ordenPrestador?.x_img_receta) {
          <div class="row form-switch ps-0 mb-4">
            <div class="col-3 col-lg-8 title-product text-dark">
              <b>Receta:</b>
            </div>
            <div class="col-9 col-lg-2 col-4 col-lg-4 text-end" style="font-size:0.9em; cursor:pointer; text-decoration:underline;" (click)="openFile()">
              Ver receta
            </div>
          </div>
        }
      </div>

      <hr class="divisor mt-0 mb-1" />

      @if (readOnly()) {
        <div class="alert alert-info mt-3 mb-2 text-center" role="alert">
          <small>Ya respondiste esta solicitud. Estos son los datos enviados al paciente.</small>
        </div>
      }

      <div class="row-cols-12 mt-0">
        <div class="row p-3 pb-1">
          <div class="col-12 col-lg-8">
            <div class="text-center text-sm-start title-product fw-bold">
              Fecha propuesta 1
            </div>
            @if (!readOnly()) {
              <div class="text-center text-sm-start description-product">
                Seleccione la fecha y hora disponible para el turno
              </div>
            }
          </div>
          <div class="col-12 col-lg-4 fw-bold fieldInfo text-end text-truncate">
            @if (readOnly()) {
              <div class="add-number p-1 m-2">
                {{ d_fecha_uno_prestador ? (d_fecha_uno_prestador | date:'dd/MM/yyyy HH:mm') + ' hs.' : '-' }}
              </div>
            } @else {
              @if (showFechaUnoInput() || d_fecha_uno_prestador) {
                <input
                  class="add-number p-1 m-2 datetime-field"
                  type="datetime-local"
                  [(ngModel)]="d_fecha_uno_prestador"
                  name="d_fecha_uno_prestador"
                  id="d_fecha_uno_prestador"
                  (change)="onDateChange()"
                />
              } @else {
                <label
                  class="placeholder-text"
                  id="d_fecha_uno_prestador_label"
                  (click)="showFechaInput(1)">
                  dd / mm / aaaa, --:-- <i class="bi bi-calendar ms-2" style="font-weight: bold;"></i>
                </label>
              }
            }
          </div>
        </div>

        <div class="row p-3 pb-1">
          <div class="col-12 col-lg-8">
            <div class="text-center text-sm-start title-product fw-bold">
              Fecha propuesta 2
            </div>
            @if (!readOnly()) {
              <div class="text-center text-sm-start description-product">
                Seleccione la fecha y hora disponible para el turno
              </div>
            }
          </div>
          <div class="col-12 col-lg-4 fw-bold fieldInfo text-end text-truncate">
            @if (readOnly()) {
              <div class="add-number p-1 m-2">
                {{ d_fecha_dos_prestador ? (d_fecha_dos_prestador | date:'dd/MM/yyyy HH:mm') + ' hs.' : '-' }}
              </div>
            } @else {
              @if (showFechaDosInput() || d_fecha_dos_prestador) {
                <input
                  class="add-number p-1 m-2 datetime-field"
                  type="datetime-local"
                  [(ngModel)]="d_fecha_dos_prestador"
                  name="d_fecha_dos_prestador"
                  id="d_fecha_dos_prestador"
                  (change)="onDateChange()"
                />
              } @else {
                <label
                  class="placeholder-text"
                  id="d_fecha_dos_prestador_label"
                  (click)="showFechaInput(2)">
                  dd / mm / aaaa, --:-- <i class="bi bi-calendar ms-2" style="font-weight: bold;"></i>
                </label>
              }
            }
          </div>
        </div>

        <div class="row p-3 pb-1">
          <div class="col-12 col-lg-8">
            <div class="text-center text-sm-start title-product fw-bold">
              Fecha propuesta 3
            </div>
            @if (!readOnly()) {
              <div class="text-center text-sm-start description-product">
                Seleccione la fecha y hora disponible para el turno
              </div>
            }
          </div>
          <div class="col-12 col-lg-4 fw-bold fieldInfo text-end text-truncate">
            @if (readOnly()) {
              <div class="add-number p-1 m-2">
                {{ d_fecha_tres_prestador ? (d_fecha_tres_prestador | date:'dd/MM/yyyy HH:mm') + ' hs.' : '-' }}
              </div>
            } @else {
              @if (showFechaTresInput() || d_fecha_tres_prestador) {
                <input
                  class="add-number p-1 m-2 datetime-field"
                  type="datetime-local"
                  [(ngModel)]="d_fecha_tres_prestador"
                  name="d_fecha_tres_prestador"
                  id="d_fecha_tres_prestador"
                  (change)="onDateChange()"
                />
              } @else {
                <label
                  class="placeholder-text"
                  id="d_fecha_tres_prestador_label"
                  (click)="showFechaInput(3)">
                  dd / mm / aaaa, --:-- <i class="bi bi-calendar ms-2" style="font-weight: bold;"></i>
                </label>
              }
            }
          </div>
        </div>

        <hr class="divisor mt-1 mb-1" />

        <div class="row p-3 pb-2">
          <div class="col-6 col-lg-8">
            <div class="col col-lg-10 fw-bold title-total text-start">
              Precio
            </div>
            <div class="text-start description-product">
              Valor del servicio
            </div>
          </div>
          <div class="col-6 col-lg-4 fw-bold fieldInfo text-end text-truncate">
            @if (readOnly()) {
              <div class="add-number p-1 m-2">
                {{ n_precio_turno != null ? (n_precio_turno | currency:'ARS') : '-' }}
              </div>
            } @else {
              <input
                class="add-number p-1 m-2"
                type="text"
                inputmode="decimal"
                [(ngModel)]="n_precio_turno"
                name="n_precio_turno"
                (input)="onPrecioInput($event)"
                (blur)="formatPrecio()"
                placeholder="0.00"
              />
            }
          </div>
        </div>
      </div>

      <hr class="divisor mt-3 mb-1" />
    </div>

    @if (error()) {
      <div class="alert alert-danger mt-2" role="alert">
        <small>{{ error() }}</small>
      </div>
    }

    <div class="d-grid mt-4 mb-3 pb-3">
      @if (!readOnly()) {
        <div class="d-grid mt-4 mb-3 pb-3">
          <button
            type="submit"
            class="btn btn-primary btn-lg mt-0"
            (click)="finalizaResponseOrder()"
            [disabled]="loadingLocal() || loadingGlobal()">
            {{ (loadingLocal() || loadingGlobal()) ? 'Cargando...' : 'Enviar cotización revisada' }}
          </button>
        </div>
      } @else{
        <button [routerLink]="['/dashboard']" type="button" class="btn btn-primary btn-lg mt-0">
          Volver
        </button>
      }
    </div>
  </div>
} @else {
  <div class="container mt-5 fade-in-left">
    <div class="row p-3 mb-3 mt-5 align-items-center">
      <div class="mt-5">
        <div class="row form-switch ps-0 mb-3">
          <div class="col text-center sucess-text mt-5 mb-5">
            <b>¡La solicitud de turno fue respondida correctamente<br><span class="bluetext"><strong>al paciente!</strong></span></b>
          </div>
        </div>
      </div>

      <div class="d-grid mt-3 mb-2">
        <button [routerLink]="['/dashboard']" type="button" class="btn btn-primary btn-lg mt-0">
          Volver
        </button>
      </div>
    </div>
  </div>
}